import React, { useMemo } from 'react';
import * as Yup from 'yup';
import { RadioChipOption } from '@applicationKYC/FarmersQuestionnaire/components';
import { useFarmerFormValidation } from '@applicationKYC/LegalEntityQuestionnaire/validation/useFarmerFormValidation';
import { useTranslation } from 'react-i18next';
import { Field, Input, Loader } from '@single-platform/components';
import { FarmersQuestionnaireHeader } from '@applicationKYC/FarmersQuestionnaire/farmersQuestionnaire.style';
import useWindowDimensions from '@applicationKYC/LegalEntityQuestionnaire/Utils/window-size.service';
import breakpointSizes from '@applicationKYC/LegalEntityQuestionnaire/styled-theme-styles/global-style-variables.style';
import {
  FormStyles,
  PageHeader
} from '@applicationKYC/LegalEntityQuestionnaire/screens/renderPage/renderPage.style';
import { ButtonSectionWrapperStyle } from '@applicationKYC/FarmersQuestionnaire/questionnaireSections/formStyles';
import { ButtonSection } from '@applicationKYC/LegalEntityQuestionnaire/components';
import { useSelector } from 'react-redux';
import { yesNoChipOptions } from '@applicationKYC/FarmersQuestionnaire/constants';
import { selectKycAppState } from '@redux';

const defaultValues = {
  hasTrademarkName: null,
  trademarkName: null
};

export const FarmTrademarkPage = ({ onSubmit, isAtBottom }) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const { loading, farmerInformation } = useSelector((state) => state.FarmersQuestionnaireReducer);
  const applicationState = useSelector(selectKycAppState);

  const validationSchema = useMemo(
    () =>
      Yup.object({
        hasTrademarkName: Yup.boolean().required(t('validation_required_field')).nullable(),
        trademarkName: Yup.string().when('hasTrademarkName', {
          is: true,
          then: Yup.string().required(t('validation_required_field')).nullable(),
          otherwise: Yup.string().notRequired().nullable()
        })
      }),
    [t]
  );

  const existingValues = farmerInformation?.farmActivitiesSection?.farmTrademarkPage;
  const initialValues = { ...defaultValues, ...existingValues };

  const { validationHelpers, getValues, setTouchedOnAll, handleSubmit } = useFarmerFormValidation({
    initialValues,
    validationSchema
  });

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    await handleSubmit(
      async (data) => {
        if (data.hasTrademarkName === false) {
          data.trademarkName = null;
        }
        await onSubmit?.(data, 'farmTrademarkPage');
      },
      () => setTouchedOnAll()
    )();
  };

  if (loading) return <Loader />;

  const values = getValues();

  return (
    <FormStyles small={width < breakpointSizes.phone}>
      <FarmersQuestionnaireHeader>
        <PageHeader>{t('farmers_trademark_page_header')}</PageHeader>
      </FarmersQuestionnaireHeader>
      <Field
        Component={RadioChipOption}
        value={values.hasTrademarkName}
        name="hasTrademarkName"
        options={yesNoChipOptions}
        validationHelpers={validationHelpers}
        validateOnChange
        disabled={applicationState?.state === 'UserFillingApplication' ? false : true}
      />
      {values.hasTrademarkName && (
        <Field
          Component={Input}
          name="trademarkName"
          value={values.trademarkName}
          placeholder={t('farmers_trademark_name')}
          validationHelpers={validationHelpers}
          validateOnChange
          required
          disabled={applicationState?.state === 'UserFillingApplication' ? false : true}
        />
      )}
      <ButtonSectionWrapperStyle isAtBottom={isAtBottom}>
        <ButtonSection
          secondButtonClick={onHandleSubmit}
          secondButtonPrimary
          secondButtonText={
            applicationState?.state === 'UserFillingApplication'
              ? t('button_save_and_continue')
              : t('button_continue')
          }
        />
      </ButtonSectionWrapperStyle>
    </FormStyles>
  );
};
